'use client'

import dynamic from 'next/dynamic'

import type { JobPageItem, TermsConditions } from '@types'

import Button from '@components/buttons/button'
import ApplyDisclaimer from '@components/job/apply-disclaimer'

import styles from './apply-banner.module.scss'

import { useCallback, type JSX } from 'react'
import useApplyWithSonicApply from '../hooks/useApplyWithSonicApply'

const ScrollApplyButton = dynamic(() => import('./scroll-apply-button'), { ssr: false })

type BannerType = {
  dataCy?: string
  jobSource: JobPageItem['source']
  legals: TermsConditions[]
  scrollButton?: boolean
  totalInterestsShown?: number
  redirect: boolean
  externalJobUrl?: string | null
}

function ApplyBanner({
  scrollButton,
  dataCy,
  legals,
  totalInterestsShown,
  jobSource,
  redirect,
  externalJobUrl,
}: BannerType): JSX.Element {
  const applyWithSonicApply = useApplyWithSonicApply()

  const handleRedirect = useCallback(() => {
    if (redirect && externalJobUrl) {
      window.open(externalJobUrl, '_blank')
    }
  }, [redirect, externalJobUrl])

  return (
    <>
      <div className={styles.apply}>
        <p className="h2">
          {totalInterestsShown && totalInterestsShown > 25
            ? 'Don’t miss out on this top job!'
            : 'Apply now in a few quick clicks'}
        </p>
        <Button
          onClick={redirect ? handleRedirect : applyWithSonicApply}
          dataCy={dataCy}
          className={styles['apply-btn']}
          variant="yellow"
        >
          Apply now
        </Button>
        <ApplyDisclaimer termsConditions={legals} jobSource={jobSource} />
      </div>
      {scrollButton && (
        <ScrollApplyButton
          applyClick={redirect ? handleRedirect : applyWithSonicApply}
          legals={legals}
          jobSource={jobSource}
        />
      )}
    </>
  )
}

export default ApplyBanner
